export * from './original1095cReport.component';
export * from './original1095cReport.service';
export * from './original1095cWorkDetail';



// WEBPACK FOOTER //
// ./src/app/Original1095C/index.ts